import { executeGetRequest, FetchConfig } from '@api/client';
import { createFetchDocListCountPath, createFetchDocListPath, createFetchDocListsPath } from '@routing/apiUrls';
import { FetchDocListResponse } from '@models/docList/FetchDocList';
import { FetchDocListsResponse } from '@models/docLists/FetchDocLists';
import { RefreshDocListCountResponse } from '@models/docListCount/RefreshDocListCount';

export const fetchDocLists = async (docClass: string, config?: FetchConfig) => {
    const result = await executeGetRequest<FetchDocListsResponse>(createFetchDocListsPath(docClass), config);
    return result.data;
};

export const fetchDocList = async (docClass: string, listType: string, config?: FetchConfig) => {
    const result = await executeGetRequest<FetchDocListResponse>(createFetchDocListPath(docClass, listType), config);
    return result.data;
};

export const fetchDocListCount = async (docClass: string, listType: string, config?: FetchConfig) => {
    const result = await executeGetRequest<RefreshDocListCountResponse>(createFetchDocListCountPath(docClass, listType), config);
    return result.data;
};
